import theme from 'theme';

const tableStyles = {
  rows: {
    style: {
      borderBottom: `1px solid ${theme.palette.tables.border}`,
    },
  },
};

export { tableStyles };
